export const withSelectedItemCategory = (formData = {}, categorization = {}) => ({
    ...formData,
    category: categorization.category_id || formData.category,
});
